import React from 'react';
import { List, Icon, Image, Label } from 'semantic-ui-react';
import { projects } from '../../data';

export const Projects = () => {
    return (
        <List size="medium" selection verticalAlign="middle">
            {projects.map((project) => (
                <List.Item href={project.link}>
                    <Image avatar src={project.icon} />
                    <List.Content>
                        <List.Header>{project.title}</List.Header>
                    </List.Content>
                    <List.Content floated="right">
                        {(project?.icons ?? []).map((icon) => (
                            <Label>
                                <Icon name={icon.icon} /> {icon.text}
                            </Label>
                        ))}
                    </List.Content>
                </List.Item>
            ))}
        </List>
    );
};
